// @flow
// @jsx h
import Vue from 'vue'
import DiscussionForm from 'app/components/discussions/discussion-form.vue'
// import ProfileForm from 'app/components/forms/profile.vue'
import store from 'app/store'

// TODO: convert this to code splitting like views/user.js
export const DiscussionFormView = new Vue({
  store,
  render(h) {
    return <DiscussionForm />
  },
})
